type Primitives = string | number | boolean | undefined;

type PrimitiveKeys<T> = {
	[K in keyof T]-?: T[K] extends Primitives ? K : never;
}[keyof T];

type MemberIndexesArray<T> = T & { index: number };

export const getMemberIndexes = <T, TFilterKey extends PrimitiveKeys<T>, TMapKey extends PrimitiveKeys<T>>(
	items: T[],
	filterKey: TFilterKey,
	mapKey: TMapKey
): Partial<Record<string, number>> => {
	try {
		const result = (items as MemberIndexesArray<T>[])
			.reduce((acc, curr) => {
				const update = { ...curr, index: 0 };
				const lastNodeIndex = acc.map((doc) => doc[filterKey]).lastIndexOf(curr[filterKey]);
				const lastNode = acc[lastNodeIndex];

				if (lastNode) {
					update.index = lastNode.index + 1;
				}

				acc.push(update);

				return acc;
			}, [] as MemberIndexesArray<T>[])
			.reduce((acc, curr) => {
				const showCount = items.filter((doc) => doc[filterKey] === curr[filterKey]).length > 1;

				if (showCount) {
					acc[curr[mapKey] as keyof typeof acc] = curr.index + 1;
				}

				return acc;
			}, {} as Record<string, number>);

		return result;
	} catch (error) {
		return {};
	}
};
